import type { FormGuideResponse } from '@shared-types/form-guide.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, cardApiUrl } from '@utilities/WindowContext';

export const fetchMatchFormGuide = (matchId: string, numberOfMatches = 5, signal?: AbortSignal) =>
  loadFromAPIs<FormGuideResponse>(
    'v1/form-guide',
    {
      matchId,
      numberOfMatches,
    },
    {
      apiKey,
      apiUrl: cardApiUrl,
      signal,
    },
  );

export const fetchTeamFormGuide = (teamIds: string | string[], numberOfMatches = 5, signal?: AbortSignal) =>
  loadFromAPIs<FormGuideResponse>(
    'v1/form-guide',
    {
      teamIds,
      numberOfMatches,
    },
    {
      apiKey,
      apiUrl: cardApiUrl,
      signal,
    },
  );
